module.exports = __webpack_public_path__ + "static/2-d61d63ca5be4a5b5c5d521a11abf978b.png";